type PersonNames = {
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
};

export const getPersonFullName = ({
  firstName,
  lastName,
  middleName,
}: PersonNames): string | null => {
  if (!firstName && !middleName && !lastName) {
    return null;
  }

  const nameParts = [firstName, middleName, lastName].filter(
    (name): name is string => Boolean(name?.trim())
  );

  if (nameParts.length === 0) {
    return null;
  }

  return nameParts.join(" ").trim();
};
